import React, { useState, useEffect } from 'react';
import { LIST_CL_IMAGES_YELP } from '../../../utils';
import './UserGallery.css';
import axios from 'axios';
import '../Modal-calendar.css';
import { useSelector } from 'react-redux';
import { selectedClientSelector } from '../../../store/slices/selectedClient';

const YelpGallery = (props) => {
  const { selectedClient } = useSelector(selectedClientSelector);
  const [images, setImages] = useState(null);

  useEffect(() => {
    setImages(null);
  }, [props.userId]);

  useEffect(() => {
    const handleLoadImages = async (imgs) => {
      const items = imgs.reverse().map((data, index) => {
        const urlOriginal = data?.SK;
        const used = data?.isUsed;
        return (
          <div
            key={index}
            style={{
              display: 'inline-block',
              margin: 1,
              width: 'calc(50% - 2px)',
              position: 'relative'
            }}>
            {used && (
              <i
                className="far fa-dot-circle"
                style={{
                  margin: 4,
                  position: 'absolute',
                  color: 'red',
                  zIndex: 1
                }}
              />
            )}

            <img
              alt={data?.LastModified}
              onClick={() => {
                if (!props.clientName) {
                  props.setAppImage({
                    pk: data.PK,
                    sk: urlOriginal
                  });
                }
              }}
              src={urlOriginal}
              style={{
                height: props.clientName ? 130 : 110,
                width: props.clientName ? 130 : 110,
                resizeMode: 'cover',
                opacity: used ? 0.5 : 1
              }}
            />
          </div>
        );
      });

      setImages(items);
    };

    const getImages = async () => {
      if (props.userId) {
        try {
          const response = await axios.get(
            `${LIST_CL_IMAGES_YELP}/${selectedClient.id}`
          );
          if (response.data.length) {
            console.log('yelp response: ', response.data);
            handleLoadImages(response.data);
          }
        } catch (err) {
          console.error(err);
        }
      }
    };

    getImages();
  }, [props.userId]);

  return (
    <div>
      <div className="card card-app-photos pd-5">
        <div
          onContextMenu={(e) => e.preventDefault()}
          onDragStart={(e) => e.preventDefault()}
          className="images-wrapper">
          <div className="card-rows">
            {images ? (
              images
            ) : (
              <span className="d-flex align-items-center justify-content-center pd-y-13 tx-gray-400">
                No photos
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default YelpGallery;
